<template>
  <wui-btn
    v-if="!registered"
    variant="warning"
    state="alpha"
    disabled
  >
    <wui-icon
      name="callDisabled"
      :title="$t('common.callsTemporarilyUnavailable')"
    />
  </wui-btn>
  <slot v-else />
</template>

<script lang="ts" setup>
import { WuiBtn, WuiIcon } from '@wui/common-library'

import { useWebRTC } from '@/entities/webrtc'

const { registered } = useWebRTC()
</script>
